module.exports = __webpack_public_path__ + "img/banner_new.9de67c7f.jpg";